import React from "react";
import styled from "styled-components/macro";

const StyledSvg = styled.svg`
  width: var(--icon-size);
  height: var(--icon-size);
`;

export const NavIcon: React.FC = () => {
  return (
    <>
      <StyledSvg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z"
          fill="var(--secondary-black)"
        />
      </StyledSvg>
    </>
  );
};
